<template>
  <section id="top" class="mt-12 container-margin">
    <v-container fluid class="text-center">
      <div v-if="isMobile" class="mt-12">
        <span class="font-weight-black black--text custom-font headline">
          WEREK
        </span>
        <span class="font-weight-black gold-text custom-font headline">
          CONSTRUCTION
        </span>
      </div>
      <!-- Hero Image with Overlay Text -->
      <v-img
        src="@/assets/ems_images/construction_banner.webp"
        height="300"
        dark
        class="mt-10"
        gradient="to bottom, rgba(0,0,0, .1), rgba(0,0,0, .7)"
      >
      </v-img>
    </v-container>
    <HistoryConstruction />
    <v-container class="text-center">
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black gold-text custom-font"
      >
        SERVICES
      </span>
      <v-responsive class="mx-auto mb-12" width="56"> </v-responsive>
      <!-- Services List -->
      <v-row class="mt-5">
        <v-col
          v-for="({ icon, title, text }, i) in services"
          :key="i"
          cols="12"
          md="4"
        >
          <!-- Updated Card Styling -->
          <v-card
            height="400"
            class="py-12 px-4"
            color="grey lighten-3"
            flat
            elevation="2"
          >
            <v-theme-provider dark>
              <div class="my-1">
                <v-avatar color="black" size="60">
                  <v-icon large color="#ccac00" v-text="icon"></v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>
            <v-card-title
              class="justify-center font-weight-bold text-uppercase black--text no-wrap-class subtitle-1"
              v-text="title"
            ></v-card-title>

            <v-card-text class="body-1 black--text" v-html="text"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-divider class="mb-1 mt-10"></v-divider>
      <v-divider class="mb-10"></v-divider>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black gold-text custom-font"
      >
        WORK
      </span>
      <v-responsive
        class="my-10 mx-auto title font-weight-light mb-8"
        max-width="720"
        >Our skilled and reliable team forms the foundation of our success. We
        employ a meticulous selection process, including detailed interviews and
        background checks, to assemble a team that shares our dedication to
        excellence. We emphasize ongoing safety and skill enhancement through
        our in-house certification programs, such as basic fall protection, fire
        safety, health & safety, and WHMIS. Proudly recognized as a WHMIS
        training center, we ensure that each team member is WHMIS certified,
        underlining our commitment to safe work practices. To promote
        professionalism and safety, our team members are provided with uniforms
        and are required to wear them on all job sites.
      </v-responsive>
      <v-carousel hide-delimiters class="mt-10">
        <v-carousel-item v-for="(item, i) in work" :key="i">
          <v-row class="fill-height">
            <v-col
              cols="12"
              class="d-flex justify-center align-center position-relative"
            >
              <v-img
                :src="item.src"
                cover
                :class="{ 'my-image': !isMobile, 'my-image-mobile': isMobile }"
              ></v-img>
              <v-container
                class="position-absolute white--text text-center overlay-text"
                :class="{ 'overlay-text-mobile': isMobile }"
                style="
                  bottom: 0;
                  left: 0;
                  right: 0;
                  background-color: rgba(0, 0, 0, 0.5);
                "
              >
                <span
                  :class="{ headline: !isMobile, 'headline-mobile': isMobile }"
                  >{{ item.title }}</span
                >
                <p
                  :class="{
                    description: !isMobile,
                    'description-mobile': isMobile,
                  }"
                >
                  {{ item.description }}
                </p>
              </v-container>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
  </section>
</template>




<script>
import HistoryConstruction from "./HistoryConstruction.vue";
import { mapGetters } from "vuex";
export default {
  name: "BuildingMaintenanceServicesPage",
  components: {
    HistoryConstruction,
  },

  computed: {
    ...mapGetters(["isMobile"]),
  },
  data() {
    return {
      services: [
        {
          icon: "mdi-hammer-screwdriver",
          title: "General Contracting",
          text: "We provide comprehensive general contracting services, managing all aspects of your construction or renovation project. From planning and coordination to execution and completion, we ensure a smooth and successful project.",
        },
        {
          icon: "mdi-wall",
          title: "Drywall",
          text: "We provide drywall installation, repair, and finishing services. Our skilled team ensures smooth and seamless drywall surfaces, creating a solid foundation for further design and finishing work.",
        },
        {
          icon: "mdi-grid-large",
          title: "Tile Installation and Repair",
          text: "Our skilled craftsmen are experienced in tile installation and repair. Whether it's for floors, walls, or backsplashes, we deliver high-quality tile work that enhances the aesthetics and functionality of your space.",
        },
        {
          icon: "mdi-shower-head",
          title: "Bathroom Remodeling",
          text: "With expertise in bathroom renovations, we bring your vision to life. From fixtures and tiling to plumbing and electrical work, we handle all aspects of bathroom remodeling to create a functional and visually appealing space.",
        },
        {
          icon: "mdi-brush",
          title: "Painting",
          text: "We offer professional painting services for both interior and exterior surfaces. Our team uses premium-quality paints and meticulous techniques to achieve flawless finishes that breathe new life into your property.",
        },
        {
          icon: "mdi-home-roof",
          title: "Stucco",
          text: "Werek Construction offers stucco services, including installation, repair, and maintenance. Our stucco work adds durability, insulation, and aesthetic value to your property.",
        },
        {
          icon: "mdi-floor-plan",
          title: "Flooring",
          text: "Werek Construction specializes in flooring installations. Whether you prefer hardwood, laminate, vinyl, or tile flooring, our experts deliver precise installations that transform your space.",
        },
        {
          icon: "mdi-home",
          title: "Roofing",
          text: "We specialize in shingle roofing services, ensuring the protection and integrity of your property. Whether it's roof installation, repair, or maintenance, our skilled team delivers reliable and long-lasting solutions.",
        },
      ],
      work: [
        {
          src: require("@/assets/ems_images/richmond.webp"),
          title: "798/800 Richmond St W Toronto, ON", // Title in Capital Case
          description:
            "Full interior refurbishment of buildings interior finishes, tiles, framing drywall, construction of recreation facilities.", // Description in Sentence Case
        },
        {
          src: require("@/assets/ems_images/training_rinks.webp"),
          title: "National Training Rinks (NTR Richmond Hill, ON)", // Title in Capital Case
          description:
            "Full design and construction of two ice surface hockey rinks in Toronto area.", // Description in Sentence Case
        },
        // ... any additional images with their respective titles and descriptions
      ],
    };
  },
};
</script>

<style scoped>
.my-image {
  max-width: 100%;
  max-height: 500px;
}
.my-image-mobile {
  max-height: 300px; /* Adjust for mobile */
}
.overlay-text {
  padding: 16px;
}
.overlay-text-mobile {
  padding: 18px; /* Smaller padding for mobile */
}
.headline {
  font-size: 1.5rem;
}
.headline-mobile {
  font-size: 1rem; /* Smaller font size for mobile */
}
.description {
  font-size: 1rem;
}
.description-mobile {
  font-size: 0.8rem; /* Smaller description font for mobile */
}
.no-wrap-class {
  word-break: keep-all;
  hyphens: manual;
}

.gold-text {
  color: #ccac00; /* Darker gold color */
}

.container-margin {
  margin-bottom: 200px; /* Offset by the height of v-app-bar */
}

.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
</style>